import React, { useContext } from 'react';
import { StateContext } from "../../../state/index";
import LoadingPage from "../../library/LoadingPage";

export const LoadingView = () => {
  const [{configuration}] = useContext(StateContext);
  const { loading } = configuration.recipientLogin;
  return <LoadingPage {...loading}/>
};

export default LoadingView;
